import React from 'react';

export const IconArrowDownSlim = (
  <svg aria-label="Icon Arrow Down Slim" width="1em" height="1em" viewBox="0 0 1024 1024">
    <path fill="currentColor" fillRule="evenodd" d="M725.342 479.945c0 3.371-1.28 6.315-3.84 8.875l-179.285 179.285c-2.603 2.603-5.547 3.84-8.875 3.84-3.371 0-6.315-1.237-8.875-3.84l-179.285-179.285c-2.56-2.56-3.84-5.504-3.84-8.875 0-3.328 1.28-6.272 3.84-8.832l19.243-19.285c2.56-2.56 5.504-3.84 8.875-3.84 3.328 0 6.272 1.28 8.875 3.84l151.168 151.211 151.168-151.211c2.56-2.56 5.504-3.84 8.875-3.84 3.328 0 6.272 1.28 8.832 3.84l19.285 19.285c2.56 2.56 3.84 5.504 3.84 8.832z" />
  </svg>
);
